import { useQueryClient } from '@tanstack/react-query';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export const useHaveVestingTasks = ({
  companyId,
  enabled = true,
  stakeholderId,
}: {
  companyId: string;
  enabled?: boolean;
  stakeholderId: string;
}) => {
  const queryClient = useQueryClient();
  const {
    data: isHaveVestingTasks,
    isSuccess,
    isLoading,
  } = useAppQuery({
    queryKey: [QueryKey.IS_HAVE_VESTING_TASKS, companyId, stakeholderId],
    queryFn: () =>
      ApiService.get<string>({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'stakeholders', stakeholderId, 'is-have-vesting-tasks'],
      }),
    enabled: enabled && !!companyId && !!stakeholderId,
  });

  const invalidateQuery = () => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.IS_HAVE_VESTING_TASKS] });
  };

  return {
    invalidateQuery,
    isHaveVestingTasks: JSON.parse(isHaveVestingTasks || 'false') as boolean,
    isSuccess,
    isLoading,
  };
};
